export default __webpack_public_path__ + "static/media/forgot_pass.6d915c23.png";